<div class="footer-container">
    <div class="shop-info">
        <div class="address">
            <span>332 Smith St, Collingwood VIC 3066</span>
        </div>
    </div>
    <div class="google-maps-embed">
        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1576.30317838742!2d144.98335497606615!3d-37.79926399491393!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6ad643378b43ddcb%3A0x8a8055c57ef86526!2sKenneth%20Geoffrey&#39;s%20Barber%20Shop!5e0!3m2!1sen!2sau!4v1607220524409!5m2!1sen!2sau" allowfullscreen="" aria-hidden="false" tabindex="0"></iframe>
    </div>
</div>